<template>
  <div class="form-group">
    <div class="mar-lt-20">
      <label class="pad-bt-5">{{$t('upload.uploadImagesArchive')}}</label>
      <el-upload
        action=""
        :on-change="handleChange"
        :on-remove="handleRemove"
        :on-exceed="handleExceed"
        :limit="1"
        :auto-upload="false"
        accept='.zip'
        ref="upload">
        <el-button slot="trigger" class="btn add mar" size="small" type="primary">{{$t('upload.browse')}}</el-button>
        <el-button :disabled="!file || uploading" :loading="uploading" style="margin-left: 10px;" class="btn add mar" size="small" type="primary" @click="upload">{{$t('upload.upload')}}</el-button>
        <div class="el-upload__tip" slot="tip">{{$t('productImport.step3Hint')}}</div>
        <span class="el-upload-list__item-actions"></span>
      </el-upload>
      <el-progress v-if="uploading" :percentage="progress" class="pad-bt-5"></el-progress>
    </div>
  </div>
</template>
<script>
  import swal from 'sweetalert2'

  // 20MB raw -> ~27MB base64 per request (cloudflare limit is 100MB)
  const CHUNK_SIZE = 20 * 1024 * 1024
  const CHUNK_RETRIES = 3

  export default {
    name: 'archive-input',
    inheritAttrs: false,
    props: {
      location: Object
    },
    data () {
      return {
        apiUrl: '',
        file: null,
        uploading: false,
        progress: 0
      }
    },
    created () {
      this.apiUrl = process.env.API_BASE_URL
    },
    methods: {
      beforeUpload (file) {
        const isOkSize = file.size / 1024 / 1024 < 500
        var self = this
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            title: self.$t('validations.archiveSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          }).then(() => {})
          .catch(() => {})
        }
        return isOkSize
      },
      handleChange (file, fileList) {
        const isOkSize = file.size / 1024 / 1024 < 500
        const isZip = file.raw.type.includes('zip')
        var self = this
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            text: self.$t('validations.archiveSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          }).then(() => {})
          .catch(() => {})
          this.$refs.upload.clearFiles()
        } else if (!isZip) {
          swal({
            toast: true,
            type: 'warning',
            text: self.$t('validations.wrongFormat'),
            position: 'top-end',
            showConfirmButton: true,
            timer: 3000
          }).then(() => {})
          .catch(() => {})
          this.$refs.upload.clearFiles()
        } else {
          self.file = file.raw
        }
      },
      handleRemove (file, fileList) {
        if (fileList.length === 0) {
          this.file = null
          this.$refs.upload.files = []
        }
      },
      handleExceed (files, fileList) {
        var self = this
        swal({
          toast: true,
          text: self.$t('validations.removePhoto'),
          type: 'warning',
          position: 'top-end',
          showConfirmButton: true
        })
      },
      postChunk (data) {
        return new Promise((resolve) => {
          this.apiRequest('/import-location/products/images/', 'POST', data, resolve)
        })
      },
      async sendChunk (data) {
        let response = null
        for (let attempt = 0; attempt < CHUNK_RETRIES; attempt++) {
          response = await this.postChunk(data)
          if (response && response.status) {
            return response
          }
        }
        return response
      },
      async upload () {
        const file = this.file
        if (!file || this.uploading) {
          return
        }
        this.uploading = true
        this.progress = 0

        const uploadId = Date.now().toString(36) + Math.random().toString(36).slice(2, 10)
        let response = null
        try {
          for (let offset = 0; offset < file.size; offset += CHUNK_SIZE) {
            const end = Math.min(offset + CHUNK_SIZE, file.size)
            const chunk = await this.getBase64(file.slice(offset, end))
            response = await this.sendChunk({
              token: this.$session.get('token'),
              location_id: this.location.id,
              company_id: this.$session.get('selectedCompany'),
              upload_id: uploadId,
              offset: offset,
              total_size: file.size,
              is_last: end >= file.size ? 1 : 0,
              chunk: chunk
            })
            if (!response || !response.status) {
              break
            }
            this.progress = Math.round(end / file.size * 100)
          }
        } catch (e) {
          response = null
        }
        this.uploading = false

        if (response && response.status) {
          swal({
            toast: true,
            text: this.$t('general.success'),
            type: 'success',
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          })
          this.file = null
          this.$refs.upload.clearFiles()
        } else {
          swal({
            toast: true,
            text: this.$t('general.error'),
            type: 'error',
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          })
        }
      }
    }
  }
</script>

<style>
  p {
    overflow: hidden;
  }
  .mb-5 {
    margin-bottom: 2rem;
  }
  .ml-4 {
    margin-left: 1.25rem;
  }
  .px-0 {
    padding-left: 0;
    padding-right: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Inputs/ArchiveInput.vue